
















































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import Transaction from '@/models/Accounts/Shared/Transactions/Transaction';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import DebitCreditCode from '@/models/Shared/DebitCreditCode';

@Component({ name: 'InstitutionalAccountTransactionDetailsDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    dialog = false;
    DebitCreditCode = DebitCreditCode;

    @Prop({required: true})
    transaction: Transaction;

    // TODO: This is a workaround until the API returns the balance in an Amount object format
    get formattedBalance() {
        return {
            amount: this.transaction.balance,
            currency: this.transaction.amount.currency
        }
    }

    // TODO: This is a workaround until the API returns the availableBalance in an Amount object format
    get formattedAvailableBalance() {
        return {
            amount: this.transaction.availableBalance,
            currency: this.transaction.amount.currency
        }
    }

}
